var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "partnet-point-index"
  }, [_vm.fetching ? _c('p', [_c('Loading')], 1) : [_c('Tabs'), _vm._m(0), _c('div', {
    staticClass: "s-p-3"
  }, [_c('div', [_c('label', {
    staticClass: "field__label"
  }, [_vm._v(" 請輸入序號兌換寶雅點數 ")]), _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    staticClass: "field__input flex-fill mr-2",
    attrs: {
      "placeholder": "輸入優惠券代碼"
    }
  }), _c('button', {
    staticClass: "s-btn s-btn-primary s-btn-sm w-auto text-nowrap px-4",
    on: {
      "click": function click($event) {
        [_vm.redeem, _vm.redeemFail][Math.random() > 0.5 ? 0 : 1]();
      }
    }
  }, [_vm._v("確認")])])]), _c('div', {
    staticClass: "partnet-point-index__list"
  }, [_c('div', {
    staticClass: "divider"
  }, [_vm._v("可兌換")]), _vm._l(_vm.availables, function (i, idx) {
    return _c('Item', {
      key: idx,
      attrs: {
        "item": i
      }
    });
  })], 2), _c('div', {
    staticClass: "partnet-point-index__list"
  }, [_c('div', {
    staticClass: "partnet-point-index__list__divider"
  }, [_vm._v("無法兌換")]), _vm._l(_vm.availables, function (i, idx) {
    return _c('Item', {
      key: idx,
      attrs: {
        "item": i
      }
    });
  })], 2)])]], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-p-3"
  }, [_c('div', {
    staticClass: "s-bg-white rounded rounded-2 d-flex partnet-point-index__point"
  }, [_c('div', {
    staticClass: "text-center w-50"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v("5,250")]), _c('div', {
    staticClass: "s-text-xs"
  }, [_vm._v("我的點數")])]), _c('div', {
    staticClass: "text-center w-50"
  }, [_c('div', {
    staticClass: "s-text-secondary mb-2"
  }, [_vm._v("1,250")]), _c('div', {
    staticClass: "s-text-xs"
  }, [_vm._v("2025/12/31即將到期")])])])]);
}]

export { render, staticRenderFns }